(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/views/pages/result-page.js') >= 0) return;  svs.modules.push('/modules/lotto/views/pages/result-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.templates=_svs.lotto.templates||{};
svs.lotto.templates.result_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngResultRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-lotto-result_page'] = svs.lotto.templates.result_page;
})(svs, Handlebars);


 })(window);